import React from 'react';
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
} from '@heroicons/react/24/outline';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/solid';

const Footer = () => {
  const whatsappURL = `https://wa.me/2349098370120?text=Hello%20KambiHome%2C%20I%20would%20like%20to%20make%20an%20inquiry.`;

  return (
    <footer className="bg-green-700 text-white px-4 py-14">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 px-2 sm:px-6">

        {/* Brand Info */}
        <div className="transition transform hover:scale-[1.02] duration-300">
          <h3 className="text-2xl font-bold mb-3">KambiHome</h3>
          <p className="text-sm text-green-100 leading-relaxed">
            Smart global shopping made local. Powered by AliExpress, tailored for Nigerians and the diaspora.
          </p>
        </div>

        {/* Contact Info */}
        <div className="transition transform hover:scale-[1.02] duration-300">
          <h4 className="font-semibold mb-3 text-lg">Contact Us</h4>
          <p className="flex items-center gap-2 text-sm">
            <PhoneIcon className="w-5 h-5 text-green-200" /> +234 909 837 0120
          </p>
          <p className="flex items-center gap-2 text-sm mt-2">
            <PhoneIcon className="w-5 h-5 text-green-200" /> +1 302 469 1130
          </p>
          <p className="flex items-center gap-2 text-sm mt-2">
            <EnvelopeIcon className="w-5 h-5 text-green-200" /> talktous@kambihome.com
          </p>
        </div>

        {/* Office Addresses */}
        <div className="transition transform hover:scale-[1.02] duration-300">
          <h4 className="font-semibold mb-3 text-lg">Our Offices</h4>

          <p className="flex gap-2 text-sm mb-4">
            <MapPinIcon className="w-5 h-5 text-green-200 mt-1" />
            <span>
              <strong className="text-white">Business Address:</strong><br />
              35 Igando-Ikotun Road (Suite 19, Praise Plaza), <br />
              opposite Fidelity Bank Igando Lagos
            </span>
          </p>
        </div>

        {/* WhatsApp CTA and Socials */}
        <div className="transition transform hover:scale-[1.02] duration-300">
          <h4 className="font-semibold mb-3 text-lg">Connect With Us</h4>

          <a
            href={whatsappURL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-green-700 w-full font-semibold py-2 px-4 rounded-md inline-flex items-center gap-2 hover:bg-green-100 transition mb-4 shadow"
          >
            <ChatBubbleLeftRightIcon className="w-5 h-5" />
            Chat on WhatsApp
          </a>

          <div className="flex gap-4 mt-2 text-green-200">
            <a href="#" className="hover:text-white transition">Facebook</a>
            <a href="#" className="hover:text-white transition">Instagram</a>
            <a href="#" className="hover:text-white transition">X</a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-center text-xs text-green-100 mt-12">
        &copy; {new Date().getFullYear()} KambiHome. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
